export const wizardStyles = `
.gb-page { max-width: 860px; margin: 0 auto; padding: 20px 16px; min-height: 100vh; font-family: 'Inter', -apple-system, sans-serif; background: var(--surface-base); color: var(--text-primary); }
.gb-loading { display: flex; align-items: center; gap: 10px; justify-content: center; padding: 60px 20px; color: var(--text-muted); font-size: 15px; }

/* Header */
.gb-pg-header { margin-bottom: 20px; }
.gb-back { background: none; border: 1px solid var(--border-default); color: var(--text-secondary); padding: 6px 14px; border-radius: 8px; cursor: pointer; display: inline-flex; align-items: center; gap: 6px; font-size: 13px; transition: all 0.15s; margin-bottom: 12px; }
.gb-back:hover { border-color: var(--border-hover); color: var(--text-primary); }
.gb-badge { display: inline-block; padding: 3px 10px; border-radius: 999px; font-size: 11px; font-weight: 600; background: rgba(245,158,11,0.12); color: #fbbf24; border: 1px solid rgba(245,158,11,0.2); text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 8px; }
.gb-pg-header h1 { font-size: 26px; font-weight: 700; margin: 4px 0; }
.gb-pg-header p { color: var(--text-secondary); font-size: 14px; margin: 0; }

/* Step bar */
.gb-step-bar { display: flex; gap: 4px; margin-bottom: 12px; overflow-x: auto; }
.gb-step {
  position: relative; overflow: hidden;
  display: flex; align-items: center; gap: 6px;
  padding: 8px 14px; border-radius: 10px;
  background: var(--surface-card); border: 1px solid var(--border-default);
  font-size: 12px; color: var(--text-muted); flex-shrink: 0;
  transition: all 0.15s;
  cursor: pointer; font-family: inherit;
}
.gb-step:hover { color: var(--text-secondary); border-color: var(--border-hover); }
.gb-step.active { color: var(--text-secondary); border-color: var(--border-hover); }
.gb-step.current { background: rgba(245,158,11,0.08); color: #fbbf24; border-color: rgba(245,158,11,0.3); }
.gb-step.done { color: #22c55e; border-color: rgba(34,197,94,0.35); background: rgba(34,197,94,0.06); }
.gb-step.done .gb-step-num { background: #22c55e; color: var(--surface-base); }
.gb-step-num { width: 20px; height: 20px; border-radius: 50%; background: var(--surface-card); display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 11px; }
.gb-step.current .gb-step-num { background: #fbbf24; color: var(--surface-base); }
.gb-step-label { font-weight: 600; }
.gb-step-progress {
  position: absolute; left: 0; right: 0; bottom: 0;
  height: 2px;
  background: linear-gradient(90deg, rgba(251,191,36,0.55), rgba(34,197,94,0.75));
  transform-origin: left center;
  transition: transform 300ms ease-out;
  pointer-events: none;
}
.gb-step.done .gb-step-progress { background: #22c55e; }

/* Overall progress bar */
.gb-overall-progress {
  position: relative;
  height: 8px;
  background: var(--surface-card);
  border: 1px solid var(--border-default);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 18px;
}
.gb-overall-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #fbbf24, #22c55e);
  transition: width 320ms ease-out;
}
.gb-overall-progress-label {
  position: absolute; right: 8px; top: -22px;
  font-size: 11px; font-weight: 700;
  color: var(--text-muted);
  letter-spacing: 0.04em;
}

/* Save state indicator (top-right of header) */
.gb-pg-header { display: flex; justify-content: space-between; align-items: flex-start; gap: 16px; flex-wrap: wrap; }
.gb-save-state {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  background: var(--surface-card);
  border: 1px solid var(--border-default);
  font-size: 12px; font-weight: 600;
  color: var(--text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}
.gb-save-idle   { color: var(--text-muted); }
.gb-save-dirty  { color: #fbbf24; border-color: rgba(251,191,36,0.35); background: rgba(251,191,36,0.08); }
.gb-save-saving { color: #60a5fa; border-color: rgba(96,165,250,0.35); background: rgba(96,165,250,0.08); }
.gb-save-saved  { color: #22c55e; border-color: rgba(34,197,94,0.35);  background: rgba(34,197,94,0.06); }
.gb-save-error  { color: #ef4444; border-color: rgba(239,68,68,0.40);  background: rgba(239,68,68,0.08); }


/* Card */
.gb-card { background: var(--surface-card); border: 1px solid var(--border-default); border-radius: 16px; padding: 24px; margin-bottom: 16px; }
.gb-review-head { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 4px; }
.gb-review-head h2 { margin: 0; }
.gb-card h2 { font-size: 18px; font-weight: 700; margin: 0 0 4px; }
.gb-hint { color: var(--text-muted); font-size: 13px; margin: 0 0 18px; }

/* Field */
.gb-field { margin-bottom: 14px; }
.gb-field label { display: block; font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--text-muted); margin-bottom: 6px; }
.gb-field input, .gb-field textarea {
  width: 100%; padding: 10px 12px; border-radius: 10px;
  background: var(--surface-base); border: 1px solid var(--border-default);
  color: var(--text-primary); font-size: 14px; font-family: inherit;
  transition: border-color 0.15s;
}
.gb-field input:focus, .gb-field textarea:focus { outline: none; border-color: #fbbf24; }
.gb-field textarea { resize: vertical; min-height: 80px; }
.gb-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 0 16px; }

/* List field */
.gb-list-field { margin-bottom: 16px; }
.gb-list-field > label { display: block; font-size: 12px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.04em; color: var(--text-muted); margin-bottom: 6px; }
.gb-list-input-row { display: flex; gap: 6px; }
.gb-list-input-row input { flex: 1; padding: 10px 12px; border-radius: 10px; background: var(--surface-base); border: 1px solid var(--border-default); color: var(--text-primary); font-size: 14px; font-family: inherit; }
.gb-list-input-row input:focus { outline: none; border-color: #fbbf24; }
.gb-list-add { background: rgba(245,158,11,0.1); border: 1px solid rgba(245,158,11,0.25); color: #fbbf24; padding: 10px 12px; border-radius: 10px; cursor: pointer; display: flex; align-items: center; transition: all 0.15s; }
.gb-list-add:hover { background: rgba(245,158,11,0.2); }
.gb-list-items { list-style: none; padding: 0; margin: 8px 0 0; display: flex; flex-direction: column; gap: 4px; }
.gb-list-items li { display: flex; align-items: center; justify-content: space-between; padding: 8px 12px; background: var(--surface-base); border: 1px solid var(--border-default); border-radius: 8px; font-size: 13px; color: var(--text-secondary); gap: 8px; }
.gb-list-items li span { flex: 1; }
.gb-list-rm { background: none; border: none; color: var(--text-muted); cursor: pointer; padding: 4px; border-radius: 4px; display: flex; align-items: center; transition: color 0.15s; }
.gb-list-rm:hover { color: var(--color-danger); }

/* Nav */
.gb-nav { display: flex; justify-content: space-between; align-items: center; margin-top: 20px; }
.gb-prev, .gb-next { display: inline-flex; align-items: center; gap: 4px; padding: 10px 18px; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.15s; }
.gb-prev { background: none; border: 1px solid var(--border-default); color: var(--text-secondary); }
.gb-prev:hover { border-color: var(--border-hover); color: var(--text-primary); }
.gb-next { background: #fbbf24; border: none; color: #1a1a2e; font-weight: 700; }
.gb-next:hover { filter: brightness(1.1); }

/* Status row */
.gb-status-row { display: flex; gap: 8px; margin-bottom: 20px; flex-wrap: wrap; }
.gb-status-btn { display: inline-flex; align-items: center; gap: 5px; padding: 8px 14px; border-radius: 999px; font-size: 12px; font-weight: 600; cursor: pointer; background: var(--surface-base); border: 1px solid var(--border-default); color: var(--text-muted); transition: all 0.15s; }
.gb-status-btn.selected { border-color: var(--btn-accent); color: var(--btn-accent); background: color-mix(in srgb, var(--btn-accent) 10%, transparent); }

/* Actions */
.gb-actions { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 10px; margin-top: 16px; }
.gb-btn-save { display: inline-flex; align-items: center; gap: 6px; padding: 12px 22px; border-radius: 10px; font-size: 14px; font-weight: 700; cursor: pointer; background: #fbbf24; border: none; color: #1a1a2e; transition: all 0.15s; }
.gb-btn-save:hover { filter: brightness(1.1); }
.gb-btn-save:disabled { opacity: 0.5; cursor: not-allowed; }
.gb-btn-pdf { display: inline-flex; align-items: center; gap: 6px; padding: 12px 22px; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; background: rgba(34,197,94,0.1); border: 1px solid rgba(34,197,94,0.25); color: #22c55e; transition: all 0.15s; }
.gb-btn-case { display: inline-flex; align-items: center; gap: 6px; padding: 12px 22px; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; background: rgba(139,92,246,0.12); border: 1px solid rgba(139,92,246,0.3); color: #c4b5fd; transition: all 0.15s; }
.gb-btn-case:hover { background: rgba(139,92,246,0.22); }
.gb-btn-pdf:hover { background: rgba(34,197,94,0.2); }
.gb-actions-right { display: flex; gap: 8px; flex-wrap: wrap; }

/* Save message */
.gb-save-msg { padding: 8px 14px; border-radius: 8px; background: rgba(34,197,94,0.1); border: 1px solid rgba(34,197,94,0.2); color: var(--color-success); font-size: 13px; margin-bottom: 12px; }

/* FF link */
.gb-ff-link { padding: 8px 12px; border-radius: 8px; background: rgba(99,102,241,0.08); border: 1px solid rgba(99,102,241,0.2); color: #818cf8; font-size: 12px; margin-bottom: 14px; }
.gb-ff-link code { background: rgba(99,102,241,0.15); padding: 1px 6px; border-radius: 4px; font-size: 11px; }

/* Review sections */
.gb-review-sections { display: flex; flex-direction: column; gap: 10px; margin-bottom: 16px; }
.gb-review-block { background: var(--surface-base); border: 1px solid var(--border-default); border-radius: 12px; padding: 14px 16px; }
.gb-review-header { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
.gb-review-header h3 { font-size: 14px; font-weight: 700; margin: 0; }
.gb-review-body { font-size: 13px; line-height: 1.6; color: var(--text-secondary); }
.gb-review-row { display: flex; gap: 8px; padding: 3px 0; }
.gb-review-label { font-size: 11px; font-weight: 600; text-transform: uppercase; color: var(--text-muted); min-width: 110px; flex-shrink: 0; }
.gb-review-value { font-size: 13px; color: var(--text-primary); }
.gb-review-list { margin: 0; padding-left: 18px; }
.gb-review-list li { margin-bottom: 4px; }
.gb-review-empty { margin: 0; color: var(--text-muted); font-style: italic; }
.gb-review-text { margin: 0; white-space: pre-wrap; }

/* Disclaimer */
.gb-disclaimer { padding: 10px 14px; border-radius: 8px; background: rgba(245,158,11,0.06); border: 1px solid rgba(245,158,11,0.15); color: var(--text-muted); font-size: 11px; line-height: 1.6; font-style: italic; margin-top: 12px; }

/* Spinner */
.gb-spin { animation: gbSpin 1s linear infinite; }
@keyframes gbSpin { to { transform: rotate(360deg); } }

@media (max-width: 640px) {
  .gb-grid { grid-template-columns: 1fr; }
  .gb-actions { flex-direction: column; align-items: stretch; }
  .gb-actions-right { flex-direction: column; }
  .gb-btn-save, .gb-btn-pdf { width: 100%; justify-content: center; }
  .gb-status-row { flex-direction: column; }
  .gb-step-bar { gap: 2px; }
  .gb-step { padding: 6px 10px; font-size: 11px; }
  .gb-review-row { flex-direction: column; gap: 2px; }
  .gb-review-label { min-width: auto; }
}
`;
